"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Media {
    constructor(attrs) {
        this.attrs = attrs;
    }
    toJSON() {
        const media = {
            type: 'media',
            attrs: {
                id: this.attrs.id,
                type: this.attrs.type,
                collection: this.attrs.collection
            }
        };
        if (this.attrs.occurrenceKey) {
            media.attrs.occurrenceKey = this.attrs.occurrenceKey;
        }
        return media;
    }
}
exports.Media = Media;
//# sourceMappingURL=media.js.map